import React from 'react';
import DisplayItem from './DisplayItem';

function UserReviewItems(props) {
  const loopItems = React.useMemo(() => {
    const items = [];
    for (const [key, value] of Object.entries(props?.items || {})) {
      const obj = mapper[key] || {};
      obj.count = value;

      items.push(obj);
    }
    return items;
  }, [props?.items]);

  return loopItems.map((item, i) => {
    return <DisplayItem key={Math.random() + '' + i} {...item} />;
  });
}
// make change in __config in ReviewItems.index also
const mapper = {
  geeks: {
    link: '/users/reviews/geek_corner',
    label: 'Geek Corner',
  },
  mindMaps: {
    link: '/users/reviews/mindMaps',
    label: 'Mindmap',
  },
  notesCount: {
    link: '/users/reviews/notes',
    label: 'Notes',
  },
  stories: {
    link: '/users/reviews/stories',
    label: 'Stories',
  },
  videos: {
    link: '/users/reviews/videos',
    label: 'Videos',
  },
  ncert: {
    link: '/users/reviews/ncert_solutions',
    label: 'NCERT',
  },
  past_paper_quiz: {
    link: '/users/reviews/past_papers',
    label: 'Past papers',
  },
  qb: {
    link: '/users/reviews/question_bank',
    label: 'Question bank',
  },
  mock: {
    link: '/users/reviews/mock_test',
    label: 'Mock Exams',
  },
  previous_year: {
    link: '/users/reviews/previous_year',
    label: 'Previous Years',
  },
};

export default UserReviewItems;
